//---css
import 'vuetify/dist/vuetify.min.css'
import 'vue-snotify/styles/material.scss'
import '@mdi/font/css/materialdesignicons.css'
import 'normalize.css'
//---END css

import Vue from 'vue'
import App from './App.vue'

import Vuex from 'vuex';
import router from './router'
import store from './store'

import Vuetify from 'vuetify'
import {vuetifyOptions} from './utils/vuetify-options'

import {snotifyOptions} from './utils/snotify-options'
import Snotify from 'vue-snotify'
import { VueMaskDirective } from 'v-mask'

import './utils/filters.js'
import './utils/http'

import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = (process.env.VUE_APP_PRODUCTION_TIP !== undefined) ? process.env.VUE_APP_PRODUCTION_TIP : true;
Vue.config.ignoredElements = ['noindex']

Vue.use(Vuex)

Vue.use(Vuetify);
let vuetify = new Vuetify(vuetifyOptions);

Vue.use(Snotify, snotifyOptions);

Vue.directive('mask', VueMaskDirective);

if (process.env.VUE_APP_ACTIVE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: 'UA-105418337-4',
    router
  })
}

new Vue({
  router,
  store,
  vuetify,
  beforeCreate() {
    Vue.$snotify = this.$snotify;
  },
  render: h => h(App)
}).$mount('#app');

// next dev iteration
// * **extClient = true | false** - ифрейм интергрирован на сайте клиента, by default: false
// * **extPhone = ddd-ddd-dddd | undefined** - телефон клиента (активен, если extClient == true), by default: undefined